module.exports = __webpack_public_path__ + "img/powerfruehstueck.5786b137.png";